import { c as _c } from "react/compiler-runtime";
import { History, Search, X } from 'lucide-react';
import { MouseEvent } from 'react';
import { SEARCH_RECOMMENDED_LIMIT } from '@/constants/search';
import { useWorldSearchContext } from '@/context/WorldSearchContext';
import { Link } from '@/i18n/navigation';
import { cn } from '@/lib/utils';
type SearchSuggestionListProps = {
  showSuggestions?: boolean;
  onSearchClick: (value: string) => void;
  selectedIndex?: number;
};
export default function SearchSuggestionList(t0) {
  const $ = _c(23);
  const {
    showSuggestions: t1,
    onSearchClick,
    selectedIndex: t2
  } = t0;
  const showSuggestions = t1 === undefined ? true : t1;
  const selectedIndex = t2 === undefined ? -1 : t2;
  const {
    recentSearches,
    suggestionWorlds,
    clearRecentSearches,
    isLoadingAutocomplete,
    isLoadingRecentSearch
  } = useWorldSearchContext();
  let t3;
  if ($[0] !== isLoadingRecentSearch || $[1] !== onSearchClick) {
    t3 = (e, value) => {
      e.preventDefault();
      e.stopPropagation();
      if (isLoadingRecentSearch) {
        return;
      }
      onSearchClick(value);
    };
    $[0] = isLoadingRecentSearch;
    $[1] = onSearchClick;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleClickSearch = t3;
  let t4;
  if ($[3] !== clearRecentSearches) {
    t4 = (e_0, id) => {
      e_0.preventDefault();
      e_0.stopPropagation();
      clearRecentSearches(id);
    };
    $[3] = clearRecentSearches;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleClearRecentSearches = t4;
  let t5;
  if ($[5] !== handleClearRecentSearches || $[6] !== handleClickSearch || $[7] !== isLoadingRecentSearch || $[8] !== recentSearches || $[9] !== selectedIndex) {
    t5 = recentSearches?.map((item, index) => <div key={item.id} className={cn("group relative flex items-center justify-between gap-2 rounded-lg p-2 text-white")}><div className={cn("absolute inset-0 rounded-lg bg-[linear-gradient(90deg,rgba(255,255,255,0.05)0%,rgba(255,255,255,0)100%)] transition-opacity duration-150", index === selectedIndex ? "opacity-100" : "opacity-0 group-hover:opacity-100")} /><Link href={`/search?keyword=${item.title}`} onClick={e_1 => handleClickSearch(e_1, item.title)} className={cn("z-base absolute inset-0 rounded-lg outline-none focus:ring-1", {
        "cursor-not-allowed": isLoadingRecentSearch
      })} aria-label={item.title} /><div className="pointer-events-none relative z-interactive flex flex-1 items-center gap-2"><History className="stroke-vive-primary-20 size-5" /><span className="body-2 flex-1">{item.title}</span></div><X onClick={e_2 => {
        if (isLoadingRecentSearch) {
          return;
        }
        handleClearRecentSearches(e_2, item.id);
      }} className={cn("stroke-vive-primary-20 relative z-interactive size-5 transition-all", isLoadingRecentSearch ? "cursor-not-allowed opacity-70" : "hover:stroke-vive-white cursor-pointer hover:scale-105")} /></div>);
    $[5] = handleClearRecentSearches;
    $[6] = handleClickSearch;
    $[7] = isLoadingRecentSearch;
    $[8] = recentSearches;
    $[9] = selectedIndex;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== isLoadingAutocomplete) {
    t6 = isLoadingAutocomplete && Array.from({
      length: SEARCH_RECOMMENDED_LIMIT
    }).map(_temp);
    $[11] = isLoadingAutocomplete;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== handleClickSearch || $[14] !== recentSearches?.length || $[15] !== selectedIndex || $[16] !== showSuggestions || $[17] !== suggestionWorlds) {
    t7 = showSuggestions && suggestionWorlds?.map((item_0, index_1) => {
      const currentIndex = (recentSearches?.length || 0) + index_1;
      return <Link key={item_0.id} href={`/search?keyword=${item_0.title}`} onClick={e_3 => handleClickSearch(e_3, item_0.title)} className="group relative flex cursor-pointer items-center gap-2 rounded-lg p-2 text-white"><div className={cn("absolute inset-0 rounded-lg bg-[linear-gradient(90deg,rgba(255,255,255,0.05)0%,rgba(255,255,255,0)100%)] transition-opacity duration-150", currentIndex === selectedIndex ? "opacity-100" : "opacity-0 group-hover:opacity-100")} /><Search className="stroke-vive-primary-20 relative z-interactive size-5" /><span className="body-2 relative z-interactive flex-1">{item_0.title}</span></Link>;
    });
    $[13] = handleClickSearch;
    $[14] = recentSearches?.length;
    $[15] = selectedIndex;
    $[16] = showSuggestions;
    $[17] = suggestionWorlds;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t5 || $[20] !== t6 || $[21] !== t7) {
    t8 = <div className="max-lg:px-4 max-lg:pb-2"><div className="space-y-2 lg:space-y-1">{t5}{t6}{t7}</div></div>;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
}
function _temp(_, index_0) {
  return <div key={index_0} className="h-9 w-full animate-pulse rounded-lg bg-[linear-gradient(90deg,rgba(255,255,255,0.05)0%,rgba(255,255,255,0)100%)]" />;
}